"use client";
import React, { useEffect, useRef } from "react";
import { Card } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import growNetworking from "../../../Assets/growNetworking.png";
import customerService from "../../../Assets/customerService.png";
import price from "../../../Assets/price.png";
import quality from "../../../Assets/quality.png";
import endToEnd from "../../../Assets/end-to-end.png";

import { Image } from "react-bootstrap";

import "./HomeIntro.scss";

function HomeIntro() {

  const upgradeImageRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    const handleScrollAnimation = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate");
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(handleScrollAnimation, {
      threshold: 0.1,
    });

    if (upgradeImageRef.current) {
      observer.observe(upgradeImageRef.current);
    }

    cardRefs.current.forEach((card) => {
      if (card) {
        observer.observe(card);
      }
    });

    return () => {
      if (upgradeImageRef.current) {
        observer.unobserve(upgradeImageRef.current);
      }
      cardRefs.current.forEach((card) => {
        if (card) {
          observer.unobserve(card);
        }
      });
    };
  }, []);

  return (
    <div>
      <Container fluid className="home-about-section">
        <Container>
        <Row className="ultimate">
          <Col md={12} className="about-text">
            <h2>Funda Sourcing: Your Trusted Partner for Growth and Scale</h2>
          </Col>
        </Row>
          <Row className="ultimate">
            <Col md={8} className="about-text">
              <h4>We act as an extension of your business, empowering you to grow and succeed.</h4>
              <p>As a global sourcing company, we specialize in delivering transparent and cost-effective solutions to businesses in the United States, Canada, Australia, New Zealand, the EU, the United Kingdom, and beyond. From startups to global corporations, our end-to-end services ensure seamless operations, impeccable quality, and on-time delivery, eliminating the need for multiple intermediaries.
              </p>
            </Col>
            <Col md={4} className="about-images">
              <Image width={300} src={growNetworking} alt="funda sourcing" />
            </Col>
          </Row>

          <Row className="vibes">
            <Col md={4} className="">
              <div className="intro-numbers extra">1,000+</div>
            </Col>
            <Col md={8} className="about-text">
            <h4>Trusted Network of Suppliers and Growing</h4>
              <p>
              From sourcing to manufacturing and shipping, we handle it all. With expertise in importing goods from China and across Asia, we continually expand our product offerings to meet your evolving needs.
              </p>
            </Col>
          </Row>
        </Container>
      </Container>

      <Container fluid className="intro-contact-wrapper">
        <Container>
          <div className="intro-contact">
            <h3>Have Questions or Need Support?</h3>
            <p>Reach out to our team today and let us help you take the next step.</p>
          </div>
        </Container>
      </Container>

      <Container fluid className="intro-why-wrapper">
      <Container>
        <Row className="justify-content-center features-title pb-4">
          <h2>Why choose Funda Sourcing?</h2>
        </Row>

        <Row className="justify-content-center left">
          <Col md={6} className="equal-height-cards">
            <Card className="slide-up" ref={(el) => (cardRefs.current[0] = el)}>
              <h4>Customer Service</h4>
              <div className="flex alignCenter">
                <Image className="feature-icon" src={customerService} alt="sourcing company" />
                <p>
                We deliver exceptional results with 24/7 support, strong partnerships in Asia, and a commitment to quality and client satisfaction.
                </p>
              </div>
            </Card>
          </Col>

          <Col md={6} className="equal-height-cards">
            <Card className="slide-up" ref={(el) => (cardRefs.current[1] = el)}>
              <h4>Cost Effective</h4>
              <div className="flex alignCenter">
                <Image className="feature-icon" src={price} alt="skill" />
                <p>
                We negotiate strongly with suppliers to secure the best possible prices and outcomes, ensuring significant savings for our clients.


                </p>
              </div>
            </Card>
          </Col>

          <Col md={6} className="equal-height-cards">
            <Card className="slide-up" ref={(el) => (cardRefs.current[2] = el)}>
              <h4>Quality Control</h4>
              <div className="flex alignCenter">
                <Image className="feature-icon" src={quality} alt="source from China" />
                <p>
                We work with ethical, certified manufacturers and maintain strict quality standards, monitored by our Guangzhou-based inspectors.
                </p>
              </div>
            </Card>
          </Col>

          <Col md={6} className="equal-height-cards">
            <Card className="slide-up" ref={(el) => (cardRefs.current[3] = el)}>
              <h4>End-to-End Service</h4>
              <div className="flex alignCenter">
                <Image className="feature-icon" src={endToEnd} alt="bear" />
                <p>
                From sourcing to production and delivery, we provide seamless, fully integrated solutions tailored to your needs.
                </p>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </Container>


    </div>
  );
}

export default HomeIntro;
